var map = {
	"./sucht_A1.png": 72166,
	"./sucht_A2.png": 1335,
	"./sucht_B1.png": 55178,
	"./sucht_B2.png": 98559,
	"./sucht_C1.png": 68778,
	"./sucht_C2.png": 73115,
	"./sucht_D1.png": 1526,
	"./sucht_D2.png": 8203,
	"./sucht_E1.png": 6242,
	"./sucht_E2.png": 61338,
	"./sucht_F1.png": 72087,
	"./sucht_F2.png": 77420,
	"./sucht_G1.png": 86822,
	"./sucht_G2.png": 47793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53971;